import { QueryClient } from '@tanstack/react-query';

/**
 * Данные админки (заказы, остатки, очередь модерации) меняются постоянно и всегда должны
 * быть свежими — отсюда короткий `staleTime` и рефетч при возврате в окно: оператор,
 * переключившийся на другую вкладку, не должен принимать решения по устаревшим остаткам.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Повторять имеет смысл только сетевые сбои и 5xx. Ретрай 401/403/404/422 бессмыслен:
      // ответ не изменится, а пользователь ждёт втрое дольше до сообщения об ошибке.
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status;
        if (typeof status === 'number' && status >= 400 && status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
